import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks page transition loading state.
 * Active from NavigationStart until NavigationEnd + all HTTP requests
 * triggered by the incoming component have completed.
 */
@Injectable({ providedIn: 'root' })
export class PageLoadingService {
  private readonly _loading = new BehaviorSubject<boolean>(false);
  readonly loading$ = this._loading.asObservable();

  private pendingRequests = 0;
  private navDone = true;
  private hideTimer?: ReturnType<typeof setTimeout>;

  get isActive(): boolean {
    return this._loading.value;
  }

  navigationStart(): void {
    clearTimeout(this.hideTimer);
    this.pendingRequests = 0;
    this.navDone = false;
    this._loading.next(true);
  }

  navigationEnd(): void {
    this.navDone = true;
    this.tryHide();
  }

  requestStarted(): void {
    if (!this._loading.value) return;
    this.pendingRequests++;
    clearTimeout(this.hideTimer);
  }

  requestCompleted(): void {
    if (this.pendingRequests > 0) this.pendingRequests--;
    this.tryHide();
  }

  private tryHide(): void {
    if (this.navDone && this.pendingRequests <= 0) {
      clearTimeout(this.hideTimer);
      // Small delay prevents flicker when multiple requests fire in sequence
      this.hideTimer = setTimeout(() => this._loading.next(false), 150);
    }
  }
}
